<template>
  <div class="panorama-custom-table-cell">
    <span class="property-a">
      {{
        customParamsRowValueFormatter(
          consumerBillItem,
          monthIndex,
          propertyNameA,
        )
      }}
    </span>
    <span>|</span>
    <span class="property-b">
      {{
        customParamsRowValueFormatter(
          consumerBillItem,
          monthIndex,
          propertyNameB,
        )
      }}
    </span>
    <span>|</span>
    <span class="property-c">
      {{
        customParamsRowValueFormatter(
          consumerBillItem,
          monthIndex,
          propertyNameC,
        )
      }}
    </span>
  </div>
</template>

<script>
import {
  dateWithoutHourFormat,
  formatCurrencyFraction2,
  formatCurrencyWithoutFraction,
} from '../../../utils/index';

export default {
  props: {
    consumerBillItem: {
      type: Array,
      default: [],
      required: true,
    },
    monthIndex: {
      type: Number,
      default: 0,
      required: true,
    },
    propertyNameA: {
      type: String,
      default: '',
      required: true,
    },
    propertyNameB: {
      type: String,
      default: '',
      required: true,
    },
    propertyNameC: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    /**
     * @param {any} item
     * @param {number} monthIndex
     * @param {string} propertyName
     * @return {function(): string | number}
     */
    customParamsRowValueFormatter(item, monthIndex, propertyName) {
      const customItem = item[monthIndex];
      if (!customItem) return '-';

      return this.formatValue(propertyName, customItem[propertyName]);
    },
    /**
     * @param {string} propertyName
     * @param {string | number} propertyValue
     * @return {function(): string | number}
     */
    formatValue(propertyName, propertyValue) {
      const formatTypes = {
        kwhz: {
          fields: [
            'total_consumption',
            'distribution_energy',
            'compensated_energy',
            'accumulated_balance',
          ],
          formatFunction: formatCurrencyWithoutFraction,
        },
        money: {
          fields: [
            'totalEconomy',
            'totalCredit',
            'boletoVeins',
            'repasseUsinaValue',
            'percentagePowerPlant',
            'guaranteedDiscount',
            'grossIncomeValue',
            'grossIncomePercentage',
            'distributorInvoice',
          ],
          formatFunction: formatCurrencyFraction2,
        },
        date: {
          fields: [
            'dueDate',
            'send_boleto_date',
            'due_date_distributor',
            'date_to_paid',
          ],
          formatFunction: dateWithoutHourFormat,
        },
      };
      let formatedValue;
      for (const [key, value] of Object.entries(formatTypes)) {
        if (value.fields.includes(propertyName)) {
          formatedValue = value.formatFunction(propertyValue);
        }
      }
      return formatedValue || propertyValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.panorama-custom-table-cell {
  display: flex;
  gap: 0.2rem;
  justify-content: end;
}

.property-a {
  color: green;
}

.property-b {
  color: blue;
}

.property-c {
  color: purple;
}
</style>
